/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Prospects_Addedby2Inputs */

const en_coinvestments_prospects_addedby2 = /** @type {(inputs: Coinvestments_Prospects_Addedby2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Added by`)
};

/**
* | output |
* | --- |
* | "Added by" |
*
* @param {Coinvestments_Prospects_Addedby2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_prospects_addedby2 = /** @type {((inputs?: Coinvestments_Prospects_Addedby2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Prospects_Addedby2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_prospects_addedby2(inputs)
});
export { coinvestments_prospects_addedby2 as "coInvestments_prospects_addedBy" }